import { defaultStyleConfig } from '@builder4/shared/styles/defaultStyle';
import type { RootState } from '../store';

export const selectActiveGlobalStyle = (state: RootState) =>
  state.globalStyles.activeGlobalStyle?.globalStyle || defaultStyleConfig;
export const selectActiveGlobalStyleId = (state: RootState): string | null | undefined =>
  state.globalStyles.activeGlobalStyle?.id;
export const selectGlobalStyleList = (state: RootState) => state.globalStyles.globalStylesList;
export const selectGlobalStyleListLoading = (state: RootState) => state.globalStyles.loading;
export const selectCreateGlobalStyleLoading = (state: RootState) =>
  state.globalStyles.createGlobalStyleLoading;
export const selectUpdateGlobalStyleLoading = (state: RootState) =>
  state.globalStyles.updateGlobalStyleLoading;

// Edit style modal selectors
export const selectEditStyleModalOpen = (state: RootState) => state.globalStyles.editStyleModalOpen;
export const selectEditStyleModalData = (state: RootState) => state.globalStyles.editStyleModalData;

/** Editing style colors (for palette in style editors); null when not editing a style in the panel. */
export const selectEditingStyleColors = (state: RootState) => state.globalStyles.editingStyleColors;
